<template>
    <van-popup v-model="popupShow" round position="bottom" :close-on-click-overlay="false" @close="closeHandle()">
        <div class="content">
            <div class="content-title">
                <h4 class="title">{{ $t('selectAllergen') }}</h4>
                <van-icon name="cross" @click="popupShow = false" />
            </div>
            <div class="content-main">
                <div class="group">
                    <ul class="group-list">
                        <li class="list-item" v-for="(item, index) in list" :key="item.id">
                            <a href="javascript:void(0)" class="clickable" :class="{'active': item.selected}" @click="allergenSelect(index)">
                                <div class="picture">
                                    <img v-lazy="cutImage(item.icon, 200)" v-if="item.icon">
                                    <img src="../../assets/images/default.png" v-else>
                                </div>
                                <p class="name">{{ item.name }}</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="handle">
                <van-button @click="confirmHandle()" class="handle-btn">{{ $t('confirm') }}</van-button>
            </div>
        </div>
    </van-popup>
</template>

<script>
/**
 * 过敏源筛选
 */
import {mapMutations} from "vuex";

export default {
    name: "Allergen",
    // 组件
    components: {},
    props: {
        parentShow: {
            type: Boolean,
            default: false
        },
        allergenList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            popupShow: false,
            list: [],
        };
    },
    // 计算属性
    computed: {
    
    },
    // 监控data中的数据变化
    watch: {
        parentShow (val) {
            if (val) {
                this.initData()
            }
        }
    },
    // 方法集合
    methods: {
        ...mapMutations(['saveAllergenIds']),
        // 裁减图片
        cutImage (url, w = 200) {
            if (!url) return ''
            let suffix = url.substring(url.lastIndexOf('.'))
            return `${url}_${w}-${suffix}`
        },
        
        // 初始化数据
        initData () {
            this.popupShow = true
            this.list = JSON.parse(JSON.stringify(this.allergenList))
        },
        
        // 选择过敏源
        allergenSelect (index) {
            let itemData = this.list[index]
            itemData.selected = !itemData.selected
            this.$set(this.list, index, itemData)
        },
        // 确定
        confirmHandle () {
            let ids = this.list.filter(item => item.selected).map(inItem => inItem.id)
            this.saveAllergenIds(ids)
            this.$emit('parent-update')
            // 关闭
            this.popupShow = false
        },
        // 关闭
        closeHandle () {
            this.$emit('parent-close')
        }
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
    
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
.van-popup{
    .content{
        .content-title{
            width: 100%;
            height: 50px;
            position: relative;
            .title{
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                color: #01000D;
            }
            .van-icon-cross{
                position: absolute;
                font-size: 20px;
                top: 15px;
                right: 30px;
                color: #01000D;
                font-weight: 600;
            }
        }
        .content-main{
            max-height: 460px;
            padding: 10px 28px;
            background: #f6f6f6;
            overflow-y: auto;
            .group{
                margin-bottom: 15px;
                .group-title{
                    height: 30px;
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #01000D;
                }
                .group-list{
                    width: 100%;
                    padding-left: 25px;
                    padding-right: 25px;
                    .list-item{
                        margin-bottom: 15px;
                        width: 100%;
                        height: 84px;
                        .clickable{
                            width: 100%;
                            height: 100%;
                            padding-left: 20px;
                            padding-right: 20px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            background-color: #FFFFFF;
                            border-radius: 6px;
                            overflow: hidden;
                            .picture{
                                width: 64px;
                                height: 64px;
                                flex-shrink: 0;
                                border-radius: 6px;
                                overflow: hidden;
                                img{
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                }
                            }
                            .name{
                                flex-grow: 1;
                                max-height: 66px;
                                padding-left: 20px;
                                font-size: 16px;
                                line-height: 22px;
                                color: #01000D;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                            }
                            &.active{
                                border: 1px solid #197340;
                            }
                        }
                        &:last-of-type{
                            margin-bottom: 0;
                        }
                    }
                }
            }
            .hint{
                margin-bottom: 15px;
                line-height: 20px;
                color: #2F7A59;
                font-size: 14px;
            }
        }
        .handle{
            height: 88px;
            padding: 12px 28px 0 28px;
            .handle-btn{
                width: 100%;
                height: 44px;
                padding: 0;
                background-color: #2F7A59;
                border-radius: 8px;
                color: #FFFFFF;
                font-size: 16px;
            }
        }
    }
}
</style>
